import React, { useEffect } from "react";
import dubai1 from "../assets/images/dubai1.webp";
import aboutbanner from "../assets/images/aboutbanner.webp";

const About = () => {
  useEffect(() => {
    const hash = window.location.hash;

    if (hash) {
      setTimeout(() => {
        const element = document.querySelector(hash);

        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 100);
    }
  }, []);
  return (
    <div className="min-h-screen bg-[#FEFEFE]">
      {/* ================= HERO / newbanner ================= */}
      {/* ================= HERO / newbanner ================= */}
      <section
        className="relative overflow-hidden bg-[#12344A]"
        style={{
          backgroundImage: `
      linear-gradient(120deg, rgb(34 75 139 / 98%) 0%, rgb(0 149 218 / 90%) 50%
50%
, rgb(0 195 230 / 82%) 100%), 
url(${dubai1})
      
    `,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        {/* // linear-gradient(
      //   120deg,
      //   rgba(18,52,74,0.98) 0%,
      //   rgba(0,127,192,0.90) 50%,
      //   rgba(1,158,231,0.82) 100%
      // ),
      // url(${dubai1}) */}

        {/* DARK PREMIUM OVERLAY */}
        <div className="absolute inset-0 bg-[#12344A]/20" />

        {/* GLOW CIRCLES */}
        <div
          className="absolute -right-40 -top-40 h-[550px] w-[550px] rounded-full bg-[#019EE7]/30 blur-[100px]"
          style={{ animation: "pulseGlow 6s ease-in-out infinite" }}
        />

        <div
          className="absolute -bottom-60 -left-40 h-[600px] w-[600px] rounded-full bg-[#97BF49]/25 blur-[120px]"
          style={{ animation: "pulseGlow 7s ease-in-out infinite" }}
        />

        {/* ROTATING CIRCLE */}
        <div
          className="absolute right-[8%] top-[12%] h-[430px] w-[430px] rounded-full border border-white/10"
          style={{ animation: "rotateSlow 35s linear infinite" }}
        />

        <div
          className="absolute right-[12%] top-[18%] h-[330px] w-[330px] rounded-full border border-white/10"
          style={{ animation: "rotateSlow 25s linear infinite reverse" }}
        />

        <div className="absolute right-[17%] top-[24%] h-[230px] w-[230px] rounded-full border border-white/10" />

        {/* FLOATING DOTS */}
        <div
          className="absolute left-[10%] top-[25%] h-3 w-3 rounded-full bg-[#97BF49] shadow-[0_0_25px_rgba(151,191,73,0.9)]"
          style={{ animation: "float 4s ease-in-out infinite" }}
        />

        <div
          className="absolute left-[18%] top-[70%] h-2 w-2 rounded-full bg-white/60"
          style={{ animation: "floatSlow 5s ease-in-out infinite" }}
        />

        <div
          className="absolute right-[10%] bottom-[22%] h-3 w-3 rounded-full bg-[#B4D86F] shadow-[0_0_20px_rgba(180,216,111,0.8)]"
          style={{ animation: "float 5s ease-in-out infinite" }}
        />

        <div className="absolute left-[50%] top-[18%] h-2 w-2 rounded-full bg-white/40" />

        {/* HERO CONTENT */}
        <div className="relative z-10 mx-auto max-w-7xl px-6 pt-24 pb-6 lg:px-8 lg:py-36">
          <div className="mx-auto max-w-5xl md:text-center text-left">
            {/* BADGE */}
            <div className="mb-7 inline-flex items-center gap-3 rounded-full border border-white/20 bg-white/10 px-4 py-2 shadow-[0_10px_40px_rgba(0,0,0,0.15)] backdrop-blur-xl">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-[#97BF49] text-sm font-bold text-white shadow-[0_0_20px_rgba(151,191,73,0.55)]">
                ✦
              </span>
              <span className="text-xs font-bold uppercase tracking-[2px] text-white sm:text-sm">
                ABOUT OUR JOURNEY
              </span>
            </div>

            {/* HEADING */}
            <h1 className="text-[40px] font-black leading-[0.95] tracking-[-2px] text-white sm:text-6xl md:text-7xl lg:text-[78px]">
              Your Journey.
              <br />
              <span className="bg-gradient-to-r from-[#97BF49] via-[#B4D86F] to-white bg-clip-text text-transparent">
                Our Commitment.
              </span>
            </h1>

            {/* DESCRIPTION */}
            <p className="mx-auto md:mt-7 mt-4 max-w-3xl text-base font-medium leading-8 text-white/85 md:text-lg">
              We make every journey simpler, smoother and more memorable with
              trusted travel solutions, personalised assistance and seamless
              experiences from start to finish.
            </p>

            {/* HERO PILLS */}
            <div className="mt-9 flex flex-wrap md:justify-center justify-left gap-3">
              <div className="flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-5 py-3 shadow-lg backdrop-blur-xl transition duration-300 hover:-translate-y-1 hover:bg-white/15">
                <span className="flex h-7 w-7 items-center justify-center rounded-full bg-[#97BF49] text-sm text-white">
                  ✓
                </span>
                <span className="text-sm font-semibold text-white">
                  Trusted Travel Partner
                </span>
              </div>

              <div className="flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-5 py-3 shadow-lg backdrop-blur-xl transition duration-300 hover:-translate-y-1 hover:bg-white/15">
                <span className="flex h-7 w-7 items-center justify-center rounded-full bg-[#019EE7] text-sm text-white">
                  ★
                </span>
                <span className="text-sm font-semibold text-white">
                  Global Travel Solutions
                </span>
              </div>

              <div className="flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-5 py-3 shadow-lg backdrop-blur-xl transition duration-300 hover:-translate-y-1 hover:bg-white/15">
                <span className="flex h-7 w-7 items-center justify-center rounded-full bg-[#97BF49] text-sm text-white">
                  ♡
                </span>
                <span className="text-sm font-semibold text-white">
                  Personalised Experiences
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        id="who-we-are"
        className="relative scroll-mt-32 overflow-hidden bg-[#FEFEFE] md:py-24 py-12"
      >
        <div className="absolute -left-32 top-20 h-72 w-72 rounded-full bg-[#019EE7]/5 blur-3xl" />

        <div className="absolute -right-32 bottom-10 h-72 w-72 rounded-full bg-[#97BF49]/10 blur-3xl" />

        <div className="relative mx-auto max-w-7xl px-6 sm:px-8 lg:px-12">
          <div className="grid items-center gap-14 lg:grid-cols-2">
            {/* Left Content */}
            <div>
              <span className="mb-4 inline-block text-base font-bold tracking-[0.2em] text-[#007FC0]">
                Who We Are
              </span>

              <h2 className="text-[25px] font-bold leading-[1.1] tracking-[0.2px] text-[#12344A] md:text-5xl">
                Travel Made Simple.
                <br />
                Experiences Made Special.
              </h2>

              <p className="md:mt-6 mt-3 text-lg leading-8 text-slate-600">
                We are passionate about creating journeys that are easy to plan,
                comfortable to experience and unforgettable to remember. From
                the first flight search to your return journey, we are committed
                to making every travel experience smooth and stress-free.
              </p>

              <p className="md:mt-5 mt-3 text-lg leading-8 text-slate-600">
                Our travel solutions bring together flights, hotels, holiday
                packages, visa assistance, transfers, insurance and dedicated
                customer support, giving travellers everything they need in one
                place.
              </p>

              {/* CTA */}
              <a href="/services">
                <button
                  className="group relative md:mt-8 mt-4 overflow-hidden rounded-xl bg-gradient-to-r from-[#224b8b] via-[#0095DA] to-[#00c3e6] px-7 py-3.5 text-sm font-bold tracking-wide text-white transition-all duration-300 hover:-translate-y-1 hover:bg-[#007FC0]"
                  style={{
                    boxShadow: "0 12px 30px rgba(18,52,74,0.22)",
                  }}
                >
                  <span className="relative z-10 flex items-center gap-3">
                    Explore Our Services
                    <span className="transition-transform duration-300 group-hover:translate-x-1">
                      →
                    </span>
                  </span>

                  <span className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/20 to-transparent transition-transform duration-700 group-hover:translate-x-full" />
                </button>
              </a>
            </div>

            {/* Right Cards */}
            {/* Right Cards */}
            <div className="grid md:grid-cols-2 grid-cols-1 md:gap-5 gap-2">
              {/* Vision */}
              <div
                className="group relative overflow-hidden rounded-3xl border border-[#019EE7]/15 p-5 transition-all duration-500 hover:-translate-y-2"
                style={{ boxShadow: "0 12px 30px rgba(18,52,74,0.06)" }}
              >
                <div className="relative z-10">
                  <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-[#019EE7]/10 text-xl text-[#019EE7] shadow-sm">
                    ◈
                  </div>
                  <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#019EE7]">
                    Our Vision
                  </span>
                  <h3 className="mt-2 text-xl font-bold text-[#12344A]">
                    Meaningful Journeys
                  </h3>
                  <p className="mt-2 text-sm leading-6 text-slate-500">
                    To become a trusted travel partner creating inspiring,
                    seamless and memorable experiences for travellers around the
                    world.
                  </p>
                </div>
              </div>

              {/* Mission */}
              <div
                className="group relative md:mt-6 overflow-hidden rounded-3xl border border-[#97BF49]/20 p-5 transition-all duration-500 hover:-translate-y-2"
                style={{ boxShadow: "0 12px 30px rgba(18,52,74,0.06)" }}
              >
                <div className="relative z-10">
                  <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-[#97BF49]/15 text-xl text-[#67952B] shadow-sm">
                    ✦
                  </div>
                  <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#67952B]">
                    Our Mission
                  </span>
                  <h3 className="mt-2 text-xl font-bold text-[#12344A]">
                    Travel Made Simple
                  </h3>
                  <p className="mt-2 text-sm leading-6 text-slate-500">
                    To deliver reliable travel solutions, personalised
                    assistance and exceptional service that makes every journey
                    simple.
                  </p>
                </div>
              </div>

              {/* Values */}
              <div
                className="group relative overflow-hidden rounded-3xl border border-[#007FC0]/15 p-5 transition-all duration-500 hover:-translate-y-2"
                style={{ boxShadow: "0 12px 30px rgba(18,52,74,0.06)" }}
              >
                <div className="relative z-10">
                  <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-[#007FC0]/10 text-xl text-[#007FC0] shadow-sm">
                    ◆
                  </div>
                  <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#007FC0]">
                    Our Values
                  </span>
                  <h3 className="mt-2 text-xl font-bold text-[#12344A]">
                    Trust & Excellence
                  </h3>
                  <p className="mt-2 text-sm leading-6 text-slate-500">
                    We believe in trust, transparency, personalised service and
                    excellence in everything we do.
                  </p>
                </div>
              </div>

              {/* Promise */}
              <div
                className="group relative md:mt-6 overflow-hidden rounded-3xl border border-[#B4D86F]/25 p-5 transition-all duration-500 hover:-translate-y-2"
                style={{ boxShadow: "0 12px 30px rgba(18,52,74,0.06)" }}
              >
                <div className="relative z-10">
                  <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-[#B4D86F]/20 text-xl text-[#5C8525] shadow-sm">
                    ✓
                  </div>
                  <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#5C8525]">
                    Our Promise
                  </span>
                  <h3 className="mt-2 text-xl font-bold text-[#12344A]">
                    With You Every Step
                  </h3>
                  <p className="mt-2 text-sm leading-6 text-slate-500">
                    From planning to arrival, we are committed to providing
                    dependable support and a smooth travel experience.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="mx-auto max-w-7xl px-5 md:pb-20 pb-12">
        <img src={aboutbanner} className="w-full rounded-xl" />
      </section> */}

      <section
        id="why-choose-us"
        className="relative scroll-mt-32 overflow-hidden bg-[#F7F8F8] py-12 sm:pt-12 sm:pb-32"
      >
        {/* CURVED BACKGROUND */}
        <div className="absolute bottom-[-270px] left-[-5%] h-[620px] w-[110%] rounded-[40%] bg-white" />

        <div className="relative z-10 mx-auto max-w-7xl px-6 sm:px-8 lg:px-12">
          <div className="max-w-[760px]">
            <span className="mb-4 inline-block text-base font-bold tracking-[0.2em] text-[#007FC0]">
              Why Choose Us
            </span>
            <h2 className="text-[25px] font-bold leading-[1.1] tracking-[0.2px] text-[#12344A] sm:text-5xl">
              Your Journey, Our Expertise
            </h2>

            <p className="md:mt-6 mt-3 max-w-[700px] text-lg leading-8 text-slate-600 sm:text-xl">
              At <span className="font-bold text-[#12344A]">Voyage Plus</span>,
              we believe travel is more than just a journey - it’s a meaningful
              experience.
            </p>
          </div>

          {/* ================= SUCCESS CARDS ================= */}
          <div className="relative md:mt-16 mt-4 grid gap-6 md:grid-cols-3 lg:gap-7">
            {/* CARD 1 */}
            <div className="group relative min-h-[390px] overflow-hidden rounded-[12px] border border-[#019EE7]/10 bg-white md:px-9 px-3 md:py-10 py-4 shadow-[0_15px_45px_rgba(18,52,74,0.10)] transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_25px_60px_rgba(18,52,74,0.16)]">
              {/* TOP ICON */}
              <div className="relative z-10 mb-4">
                <div className="relative">
                  <div className="absolute inset-0 scale-75 rounded-full bg-[#019EE7]/20 opacity-0 blur-xl transition-all duration-500 group-hover:scale-125 group-hover:opacity-70" />

                  <div className="relative flex h-[68px] w-[68px] items-center justify-center rounded-full border border-[#9BC5E0]/50 bg-[#FEFEFE] shadow-[0_8px_24px_rgba(18,52,74,0.10)] transition-all duration-500 group-hover:scale-110 group-hover:border-transparent">
                    <div className="relative flex h-[54px] w-[54px] items-center justify-center rounded-full bg-gradient-to-br from-[#019EE7] to-[#007FC0] shadow-lg">
                      <span className="absolute left-[9px] top-[6px] h-[7px] w-[19px] rotate-[-25deg] rounded-full bg-white/50 blur-[1px]" />

                      <i className="las la-briefcase relative text-[25px] text-white" />
                    </div>
                  </div>
                </div>
              </div>

              <h3 className="relative z-10 text-[27px] font-extrabold tracking-[-0.8px] text-[#12344A]">
                Industry Expertise
              </h3>

              <p className="relative z-10 text-base font-medium text-slate-500">
                Experience You Can Trust
              </p>

              <div className="relative z-10 mt-7 space-y-6">
                <div className="flex gap-4">
                  <span className="mt-1 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#019EE7] text-[11px] font-bold text-white">
                    ✓
                  </span>

                  <p className="m-0 text-[15px] leading-6 text-slate-600">
                    Deep understanding of the travel industry and changing
                    traveller needs.
                  </p>
                </div>

                <div className="flex gap-4">
                  <span className="mt-1 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#97BF49] text-[11px] font-bold text-white">
                    ✓
                  </span>

                  <p className="m-0 text-[15px] leading-6 text-slate-600">
                    Experienced professionals delivering dependable travel
                    solutions.
                  </p>
                </div>

                <div className="flex gap-4">
                  <span className="mt-1 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#019EE7] text-[11px] font-bold text-white">
                    ✓
                  </span>

                  <p className="m-0 text-[15px] leading-6 text-slate-600">
                    Strong relationships with trusted travel partners and
                    suppliers.
                  </p>
                </div>
              </div>

              {/* BOTTOM ACCENT */}
              <div className="absolute bottom-0 left-0 h-1 w-0 bg-gradient-to-r from-[#224b8b] via-[#0095DA] to-[#00c3e6] transition-all duration-500 group-hover:w-full" />
            </div>

            {/* CARD 2 */}
            <div className="group relative min-h-[390px] overflow-hidden rounded-[12px] border border-[#97BF49]/15 bg-white md:px-9 px-3 md:py-10 py-4 shadow-[0_15px_45px_rgba(18,52,74,0.10)] transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_25px_60px_rgba(18,52,74,0.16)]">
              {/* TOP ICON */}
              <div className="relative z-10 mb-4">
                <div className="relative">
                  <div className="absolute inset-0 scale-75 rounded-full bg-[#97BF49]/20 opacity-0 blur-xl transition-all duration-500 group-hover:scale-125 group-hover:opacity-70" />
                  <div className="relative flex h-[68px] w-[68px] items-center justify-center rounded-full border border-[#9BC5E0]/50 bg-[#FEFEFE] shadow-[0_8px_24px_rgba(18,52,74,0.10)] transition-all duration-500 group-hover:scale-110 group-hover:border-transparent">
                    <div className="relative flex h-[54px] w-[54px] items-center justify-center rounded-full bg-gradient-to-br from-[#97BF49] to-[#67952B] shadow-lg">
                      <span className="absolute left-[9px] top-[6px] h-[7px] w-[19px] rotate-[-25deg] rounded-full bg-white/50 blur-[1px]" />
                      <i className="las la-laptop-code relative text-[25px] text-white" />
                    </div>
                  </div>
                </div>
              </div>

              <h3 className="relative z-10 text-[27px] font-extrabold tracking-[-0.8px] text-[#12344A]">
                Smart Technology
              </h3>

              <p className="relative z-10  text-base font-medium text-slate-500">
                Seamless & Efficient
              </p>

              <div className="relative z-10 mt-7 space-y-6">
                <div className="flex gap-4">
                  <span className="mt-1 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#97BF49] text-[11px] font-bold text-white">
                    ✓
                  </span>

                  <p className="m-0 text-[15px] leading-6 text-slate-600">
                    Modern technology that simplifies planning and managing
                    every journey.
                  </p>
                </div>

                <div className="flex gap-4">
                  <span className="mt-1 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#019EE7] text-[11px] font-bold text-white">
                    ✓
                  </span>

                  <p className="m-0 text-[15px] leading-6 text-slate-600">
                    Faster booking processes with reliable and accurate
                    information.
                  </p>
                </div>

                <div className="flex gap-4">
                  <span className="mt-1 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#97BF49] text-[11px] font-bold text-white">
                    ✓
                  </span>

                  <p className="m-0 text-[15px] leading-6 text-slate-600">
                    Connected travel solutions designed for modern travellers
                    and businesses.
                  </p>
                </div>
              </div>

              {/* BOTTOM ACCENT */}
              <div className="absolute bottom-0 left-0 h-1 w-0 bg-gradient-to-r from-[#224b8b] via-[#0095DA] to-[#00c3e6] transition-all duration-500 group-hover:w-full" />
            </div>

            {/* CARD 3 */}
            <div className="group relative min-h-[390px] overflow-hidden rounded-[12px] border border-[#007FC0]/10 bg-white md:px-9 px-3 md:py-10 py-4 shadow-[0_15px_45px_rgba(18,52,74,0.10)] transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_25px_60px_rgba(18,52,74,0.16)]">
              <div className="relative z-10 mb-4">
                <div className="relative">
                  <div className="absolute inset-0 scale-75 rounded-full bg-[#007FC0]/20 opacity-0 blur-xl transition-all duration-500 group-hover:scale-125 group-hover:opacity-70" />
                  <div className="relative flex h-[68px] w-[68px] items-center justify-center rounded-full border border-[#9BC5E0]/50 bg-[#FEFEFE] shadow-[0_8px_24px_rgba(18,52,74,0.10)] transition-all duration-500 group-hover:scale-110 group-hover:border-transparent">
                    <div className="relative flex h-[54px] w-[54px] items-center justify-center rounded-full bg-gradient-to-br from-[#019EE7] to-[#007FC0] shadow-lg">
                      <span className="absolute left-[9px] top-[6px] h-[7px] w-[19px] rotate-[-25deg] rounded-full bg-white/50 blur-[1px]" />
                      <i className="las la-headset relative text-[25px] text-white" />
                    </div>
                  </div>
                </div>
              </div>

              <h3 className="relative z-10 text-[27px] font-extrabold tracking-[-0.8px] text-[#12344A]">
                Personalized Service
              </h3>

              <p className="relative z-10 text-base font-medium text-slate-500">
                Support That Cares
              </p>

              <div className="relative z-10 mt-7 space-y-6">
                <div className="flex gap-4">
                  <span className="mt-1 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#019EE7] text-[11px] font-bold text-white">
                    ✓
                  </span>

                  <p className="m-0 text-[15px] leading-6 text-slate-600">
                    Personalised solutions created around your individual travel
                    requirements.
                  </p>
                </div>

                <div className="flex gap-4">
                  <span className="mt-1 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#97BF49] text-[11px] font-bold text-white">
                    ✓
                  </span>

                  <p className="m-0 text-[15px] leading-6 text-slate-600">
                    Competitive pricing without compromising on quality or
                    comfort.
                  </p>
                </div>

                <div className="flex gap-4">
                  <span className="mt-1 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-[#019EE7] text-[11px] font-bold text-white">
                    ✓
                  </span>

                  <p className="m-0 text-[15px] leading-6 text-slate-600">
                    Quick, responsive support whenever you need us throughout
                    your journey.
                  </p>
                </div>
              </div>

              {/* BOTTOM ACCENT */}
              <div className="absolute bottom-0 left-0 h-1 w-0 bg-gradient-to-r from-[#224b8b] via-[#0095DA] to-[#00c3e6] transition-all duration-500 group-hover:w-full" />
            </div>
          </div>
        </div>
      </section>

      {/* ================= WHERE WE COME FROM ================= */}
      <section
        id="where-we-come-from"
        className="relative scroll-mt-32 bg-[#FEFEFE] max-w-7xl mx-auto pb-20 pt-0"
      >
        {/* ================= BLUE BACKGROUND ================= */}
        <div className="absolute left-1/2 top-0 h-[590px] w-[100%] -translate-x-1/2 overflow-hidden rounded-b-[2px] bg-gradient-to-r from-[#224b8b] via-[#0095DA] to-[#00c3e6]"></div>

        <div className="relative z-10 mx-auto max-w-7xl px-6 md:pt-20 pt-12 sm:px-8 lg:px-12">
          <div className="max-w-6xl">
            <span className=" inline-block text-base font-bold tracking-[0.2em] text-[#97BF49]">
              Our Story
            </span>
            <h2 className="mt-3 text-[25px] font-semibold leading-[1.1] tracking-[0.2px] text-white sm:text-5xl lg:text-6xl">
              Built on Trust. Driven by Experience.
            </h2>

            <p className="md:mt-6 mt-3 max-w-[1100px] text-base font-medium leading-7 text-white/90 sm:text-lg">
              Voyage Plus is a trusted name in travel and tourism, built on
              decades of industry expertise and a commitment to reliable,
              professional service. We provide comprehensive travel solutions
              for individuals, families, and corporate clients, helping make
              every journey seamless, comfortable, and memorable.
            </p>
          </div>

          {/* ================= CARDS ================= */}
          <div className="md:mt-12 mt-6 grid gap-6 md:grid-cols-2 lg:gap-7 xl:px-24">
            {/* ================= CARD 1 ================= */}
            <div
              className="group relative min-h-[400px] overflow-hidden rounded-xl bg-white px-4 py-4 md:px-10 md:py-8"
              style={{
                boxShadow: "0 12px 35px rgba(18,52,74,0.14)",
              }}
            >
              {/* Small top icon */}
              <div className="mb-4 flex items-center gap-3">
                <div className="relative z-10 mb-3">
                  <div className="relative">
                    <div className="absolute inset-0 scale-75 rounded-full bg-[#97BF49]/20 opacity-0 blur-lg transition-all duration-500 group-hover:scale-125 group-hover:opacity-70" />

                    <div className="relative flex h-[54px] w-[54px] items-center justify-center rounded-full border border-[#B8D58A]/50 bg-[#FEFEFE] shadow-[0_6px_18px_rgba(18,52,74,0.10)] transition-all duration-500 group-hover:scale-110 group-hover:border-transparent">
                      <div className="relative flex h-[42px] w-[42px] items-center justify-center rounded-full bg-gradient-to-br from-[#97BF49] to-[#67952B] shadow-md">
                        <span className="absolute left-[7px] top-[5px] h-[5px] w-[15px] rotate-[-25deg] rounded-full bg-white/50 blur-[1px]" />

                        <i className="las la-globe relative text-[19px] text-white" />
                      </div>
                    </div>
                  </div>
                </div>

                <span className="text-lg font-semibold text-[#12344A]">
                  Where We Come From
                </span>
              </div>

              <h3 className="max-w-[500px] text-[20px] font-extrabold leading-[1.25] tracking-[-0.5px] text-[#12344A] sm:text-[28px]">
                Voyage Plus is a trusted name in travel and tourism, built on
                decades of industry expertise
              </h3>

              {/* Accent line */}

              <div className="mt-5 h-[3px] w-12 rounded-full bg-[#019EE7]" />

              <p className="mt-6 text-[15px] leading-7 text-slate-600 sm:text-base">
                We provide reliable, professional, and personalised travel
                solutions for individuals, families, and corporate clients,
                making every journey seamless, comfortable, and memorable.
              </p>

              <p className="mt-4 text-[15px] leading-7 text-slate-600 sm:text-base">
                We cater to individuals, families, and corporate clients alike,
                delivering dependable and personalised travel experiences.
              </p>

              {/* Bottom accent */}
              <div className="absolute bottom-0 left-0 h-1 w-0 bg-gradient-to-r from-[#224b8b] via-[#0095DA] to-[#00c3e6] transition-all duration-500 group-hover:w-full" />
            </div>

            {/* ================= CARD 2 ================= */}
            <div
              className="group relative min-h-[400px] overflow-hidden rounded-xl bg-white px-4 py-4 md:px-10 md:py-8"
              style={{
                boxShadow: "0 12px 35px rgba(18,52,74,0.14)",
              }}
            >
              {/* Small top icon */}
              <div className="mb-6 flex items-center gap-3">
                <div className="relative z-10">
                  <div className="relative">
                    <div className="absolute inset-0 scale-75 rounded-full bg-[#97BF49]/20 opacity-0 blur-lg transition-all duration-500 group-hover:scale-125 group-hover:opacity-70" />
                    <div className="relative flex h-[54px] w-[54px] items-center justify-center rounded-full border border-[#B8D58A]/50 bg-[#FEFEFE] shadow-[0_6px_18px_rgba(18,52,74,0.10)] transition-all duration-500 group-hover:scale-110">
                      <div className="relative flex h-[42px] w-[42px] items-center justify-center rounded-full bg-gradient-to-br from-[#97BF49] to-[#67952B] shadow-md">
                        <span className="absolute left-[7px] top-[5px] h-[5px] w-[15px] rotate-[-25deg] rounded-full bg-white/50 blur-[1px]" />
                        <i className="las la-globe relative text-[19px] text-white" />
                      </div>
                    </div>
                  </div>
                </div>

                <span className="text-lg font-semibold text-[#12344A]">
                  Where We Work
                </span>
              </div>

              <h3 className="max-w-[500px] text-[20px] font-extrabold leading-[1.25] tracking-[-0.5px] text-[#12344A] sm:text-[28px]">
                With the UAE as our base, Voyage Plus connects travelers to
                destinations
              </h3>

              {/* Accent line */}
              <div className="mt-5 h-[3px] w-12 rounded-full bg-[#97BF49]" />

              <p className="mt-6 text-[15px] leading-7 text-slate-600 sm:text-base">
                across every continent. Our reach is truly global. Backed by a
                strong international network of partners and suppliers, we offer
                up-to-date travel information and a seamless booking experience.
              </p>

              <p className="mt-4 text-[15px] leading-7 text-slate-600 sm:text-base">
                Wherever our clients choose to go, we provide consistently
                high-quality service and reliable international travel
                solutions.
              </p>
              <div className="absolute bottom-0 left-0 h-1 w-0 bg-gradient-to-r from-[#224b8b] via-[#0095DA] to-[#00c3e6] transition-all duration-500 group-hover:w-full" />
            </div>
          </div>
        </div>
      </section>

      <section
        className="relative mx-auto max-w-7xl overflow-hidden rounded-lg bg-[#0755AD] md:mt-12 md:mb-20 md:py-16 pt-10 pb-12"
        style={{
          backgroundImage: `
      linear-gradient(
        90deg,
        rgba(7, 85, 173, 0.97) 0%,
        rgba(7, 85, 173, 0.88) 40%,
        rgba(7, 85, 173, 0.62) 100%
      ),
     url("https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=1800&q=85")
    `,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        {/* Soft background glow */}
        <div className="absolute right-[-100px] top-1/2 h-80 w-80 -translate-y-1/2 rounded-full bg-[#019EE7]/10 blur-3xl" />

        <div className="relative mx-auto max-w-4xl px-6 text-left md:text-center">
          <span className="inline-block text-base font-bold tracking-[0.2em] text-[#97BF49]">
            Start Your Journey
          </span>

          <h2 className="mt-4 text-[25px] font-bold leading-[1.1] tracking-[0.2px] text-white md:text-5xl">
            Wherever You Want To Go,
          </h2>

          <h2 className="mt-2 text-[25px] font-bold leading-[1.1] tracking-[0.2px] text-white md:text-5xl">
            We'll Help You Get There.
          </h2>

          <p className="mx-auto mt-3 max-w-2xl text-lg leading-8 text-white md:mt-6">
            Let us take care of the details while you focus on discovering new
            places, creating memories and enjoying every moment of your journey.
          </p>

          <a href="/contact">
            <button
              className="group relative mt-3 overflow-hidden rounded-xl bg-[#99c04c] px-8 py-4 text-sm font-bold tracking-wide text-white transition-all duration-300 hover:-translate-y-1 md:mt-9"
              style={{
                boxShadow: "0 15px 35px rgba(18,52,74,0.2)",
              }}
            >
              <span className="relative z-10 flex items-center gap-3">
                Plan Your Journey
              </span>

              <span className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/20 to-transparent transition-transform duration-700 group-hover:translate-x-full" />
            </button>
          </a>
        </div>
      </section>

      {/* ================= ANIMATIONS ================= */}
      <style>{`
        @keyframes float {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-18px);
          }
        }

        @keyframes floatSlow {
          0%, 100% {
            transform: translate(0px, 0px);
          }
          50% {
            transform: translate(15px, -20px);
          }
        }

        @keyframes rotateSlow {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }

        @keyframes shine {
          0% {
            transform: translateX(-120%);
          }

          50%,
          100% {
            transform: translateX(120%);
          }
        }

        @keyframes pulseGlow {
          0%,
          100% {
            opacity: 0.35;
            transform: scale(1);
          }

          50% {
            opacity: 0.7;
            transform: scale(1.12);
          }
        }
      `}</style>
    </div>
  );
};

export default About;
